import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const CheckoutHeader = ({ step, title }) => {
  const { t } = useTranslation(['cart']);
  return (
    <header className="checkout-header">
      <p className="checkout-header__step">
        {t('stepOf', { current: step, total: 4 })}
      </p>
      <h1 className="checkout-header__title">{title}</h1>
      <span className="checkout-header__accent" aria-hidden="true" />
    </header>
  );
};

CheckoutHeader.propTypes = {
  step: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
};

export default CheckoutHeader;
